import { FilterKindEnum } from '../../../../../domains/global-filters/model/FilterChain';
import { getFilterMetadata } from '../../../FilterChainUtils';
import { GenericRadioTextFilter } from '../../GenericBloc/GenericRadioTextFilter/GenericRadioTextFilter';
import type {
  ContainOperation,
  EndWithOperation,
  IsOperation,
  NotContainOperation,
  RadioTextFilterValue,
  StartWithOperation,
} from '../../GenericBloc/GenericRadioTextFilter/GenericRadioTextType';
import { RadioTextFilterOperation } from '../../GenericBloc/GenericRadioTextFilter/GenericRadioTextType';
import type { AbstractSingleFilterPillsProps } from '../../SingleFilterType';
import { getLabels } from '../../../../../utils/LabelFormatter/SingleLabelFormatter/URLLabelFormatter';

const options = [
  RadioTextFilterOperation.IS,
  RadioTextFilterOperation.CONTAINS,
  RadioTextFilterOperation.NOT_CONTAINS,
  RadioTextFilterOperation.STARTS_WITH,
  RadioTextFilterOperation.ENDS_WITH,
];

export type PageURLFilterValue =
  | IsOperation
  | ContainOperation
  | NotContainOperation
  | StartWithOperation
  | EndWithOperation
  | undefined;

const placeholders = {
  [RadioTextFilterOperation.IS]: 'e.g. https://example.com/contact',
  [RadioTextFilterOperation.CONTAINS]: 'e.g. register',
  [RadioTextFilterOperation.NOT_CONTAINS]: 'e.g. register',
  [RadioTextFilterOperation.STARTS_WITH]: 'e.g. https://example.com/contact',
  [RadioTextFilterOperation.ENDS_WITH]: 'e.g. /contact',
};

// this filter is slightly different to regular URL filters in terms of options it offers (adjusted for surveys)
export function PageURLFilter({
  currentValue,
  autoFocus,
  onApply,
  onRemove,
  onDropdownHidden,
  showDropdownOnMount,
  isInactive,
}: AbstractSingleFilterPillsProps<RadioTextFilterValue>): JSX.Element {
  const metadata = getFilterMetadata(FilterKindEnum.PageURL);
  const { label1, label2 } = getLabels(currentValue, FilterKindEnum.PageURL);

  return (
    <GenericRadioTextFilter
      autoFocus={autoFocus}
      filterName={metadata.filterName}
      iconName={metadata.iconName}
      currentValue={currentValue}
      onApply={onApply}
      onRemove={onRemove}
      placeholders={placeholders}
      options={options}
      showDropdownCaret
      isInactive={isInactive}
      onDropdownHidden={onDropdownHidden}
      showDropdownOnMount={showDropdownOnMount}
      label1={label1}
      label2={label2}
    />
  );
}
